module.exports = new __parcel__URL__("amnesia-the-dark-descent.158ecd04.jpg").toString();